export const POSTER_ELEMENT_CONTAINER = 'poster-element-container';
